import { ScrollAnimationParent as ScrollAnimationParentCore } from '@studiometa/ui';
import { withMountOnMediaQuery } from '@studiometa/js-toolkit';
import ScrollAnimationChildShowreel from './ScrollAnimationChildShowreel.js';

export default class ScrollAnimationParent extends withMountOnMediaQuery(
  ScrollAnimationParentCore,
  'all',
) {
  static config = {
    ...ScrollAnimationParentCore.config,
    components: {
      ...ScrollAnimationParentCore.config.components,
      ScrollAnimationChildShowreel,
    },
  };

  scrolledInView(props) {
    if (this.$children.ScrollAnimationChild) {
      this.$children.ScrollAnimationChild.forEach((child) => {
        child.scrolledInView(props);
      });
    }
    if (this.$children.ScrollAnimationChildShowreel) {
      this.$children.ScrollAnimationChildShowreel.forEach((child) => {
        child.scrolledInView(props);
      });
    }
  }
}
